module.exports = __webpack_public_path__ + "img/artzie_logo_en_cut.099e3929.png";